import listIconSvg from "../../../../assets/svg/list-icon.svg";

interface Props {
    href: string;
    title: string;
}

const DocLink = ({ href, title }: Props) => {
    return (
        <a
            href={href}
            target="blank"
            className="btn btn-outline-secondary text-start text-nowrap"
            rel="noopener noreferrer"
            style={{width: '300px'}}
        >
            <img
                src={listIconSvg}
                className="me-2"
            />
            {title}
        </a>
    );
};

export default DocLink;
